<div class="form-field flex-col gap-1"
  [class.invalid]="!checkValidity(inputElement)"
  (click)="isTouched = true;">

  @if (hint || (label && (type !== 'checkbox' || checkboxForceEmptyLabel))) {
    <div class="flex-col">
      <div class="flex-row gap-1 middle">
        @if (label) {
          <label
            class="label"
            [innerHTML]="(type !== 'checkbox' || !editActive) ? label : '&nbsp;'">
          </label>
        }
        @if (required && editActive && type !== 'checkbox') {
          <sup class="label">*</sup>
        }
        @if (labelIconRight) {
          <i
            [ngClass]="labelIconRight"
            (click)="labelIconRightClick.emit($event)"
            [pTooltip]="labelIconRightTooltip">
          </i>
        }
        @if (isLink && checkLinkValidity(value)) {
          <a
            [href]="value"
            target="_blank">
            <i class="fas fa-external-link-alt icon-external-link"></i>
          </a>
        }
      </div>
      @if (hint) {
        <label
          class="label small"
          [innerHTML]="hint">
        </label>
      }
    </div>
  }

  @if (!editActive) {
    <div class="value">
      <div class="flex-row gap-1 middle">
        @if (icon) {
          <i [ngClass]="icon"></i>
        }
        @if (type === 'multi-select' || type === 'tags') {
          <div
            [innerHTML]="!(value || []).length ? noValueHtml : value.join('<br>')">
          </div>
        }
        @if (type !== 'date' && type !== 'multi-select' && type !== 'tags') {
          <div
            [class.wrap-link]="isLink"
            [innerHTML]="dropdownValue != null ? dropdownValue : (value != null && value !== '') ? (value | normalizeNbspRuns) : noValueHtml">
          </div>
        }
        @if (type === 'date' && dateValue) {
          <div>
            {{ dateValue | toAgnosticDateString:dateFormat }}
          </div>
        }
        @if (type === 'date' && !dateValue) {
          <div
            [innerHTML]="noValueHtml">
          </div>
        }
      </div>
    </div>
  }

  @if (type === 'checkbox' || type === 'triStateCheckbox') {
    <div class="flex-row gap-1 middle"
      style="height: 3rem;">
      <p-checkbox
        [class.tri-state]="type === 'triStateCheckbox'"
        [class.checked]="value === true"
        [class.unchecked]="value === false"
        [class.mixed]="value == null"
        binary="true"
        [disabled]="disabled"
        [indeterminate]="value == null"
        [(ngModel)]="value"
        (ngModelChange)="onChange(value)">
      </p-checkbox>
      <label class="label">
        {{ label}}
      </label>
    </div>
  }

  @if (editActive && type === 'date') {
    <p-datepicker
      [appendTo]="appendTo"
      styleClass="datepicker"
      dateFormat="mm/dd/yy"
      [disabled]="disabled"
      [inline]="inlineDatePicker"
      [minDate]="minDate | parseDate"
      [maxDate]="maxDate | parseDate"
      [(ngModel)]="dateValue"
      (onBlur)="updateValueWithDate(dateValue)"
      (onSelect)="updateValueWithDate(dateValue)">
    </p-datepicker>
  }
  @if (editActive && type === 'date' && !inlineDatePicker) {
    <i class="datepicker-icon link far fa-calendar-alt">
    </i>
  }

  @if (editActive && type === 'color') {
    <div class="flex-1 color-selector"
      [class.open]="isColorPickerOpen"
      [(colorPicker)]="value"
      (colorPickerChange)="colorValueChanged.next($event)"
      (colorPickerClose)="isColorPickerOpen = false"
      (colorPickerOpen)="isColorPickerOpen = true"
      [cpAlphaChannel]="'disabled'"
      [cpColorMode]="colorMode"
      [cpEyeDropper]="colorMode === 'color'"
      [cpOutputFormat]="'hex'"
      [cpPosition]="'auto'"
      [cpPresetColors]="options"
      [cpPresetLabel]="''"
      [cpWidth]="'198px'">
      <div class="flex-row middle"
        style="line-height: 36px; min-height: 36px;">
        @if (value) {
          <div
            class="color-circle"
            [style]="'background-color: ' + value">
          </div>
        }
        @if (!value) {
          <div
            class="placeholder">
            {{ placeholder }}
          </div>
        }
        <div class="flex-1"></div>
        <i class="pi pi-chevron-down"
          style="color: #848484; width: 1.3rem;">
        </i>
      </div>
    </div>
  }

  @if (editActive && type === 'dropdown') {
    <p-select
      [appendTo]="appendTo"
      styleClass="select"
      panelStyleClass="select-overlay"
      [disabled]="disabled"
      [filter]="dropdownFilter !== false && options?.length > 7"
      [options]="options"
      [optionLabel]="optionLabel"
      [overlayOptions]="{ baseZIndex: 2000 }"
      [placeholder]="placeholder || ''"
      [(ngModel)]="value"
      (ngModelChange)="onChange($event)"
      [showClear]="dropdownShowClear"
      [virtualScroll]="options?.length > 100"
      [virtualScrollItemSize]="49"
    [virtualScrollOptions]="{
      lazy: true,
      numToleratedItems: 4,
    }">
      <ng-template let-item pTemplate="selectedItem">
        @if (item) {
          <div
            class="flex-row gap-1 middle">
            @if (item.icon) {
              <div class="select-icon" [ngClass]="item.icon"></div>
            }
            <div class="ellipsis">
              {{ item[optionLabel || 'label'] }}
            </div>
          </div>
        }
      </ng-template>
      <ng-template let-item pTemplate="item">
        <div class="flex-col gap-1">
          @if (item) {
            <div
              class="flex-row gap-1 middle"
              style="min-height: 2rem">
              @if (item.icon) {
                <div class="dropdown-icon" [ngClass]="item.icon"></div>
              }
              <div [class.ellipsis]="item.title || item.description">
                {{ item[optionLabel || 'label'] }}
              </div>
            </div>
          }
          @if (item.title || item.description) {
            <div
              class="description"
              [innerHTML]="item.title || item.description || ''">
            </div>
          }
        </div>
      </ng-template>
    </p-select>
  }

  @if (editActive && type === 'listbox') {
    <p-listbox
      #inputElement
      [appendTo]="appendTo"
      styleClass="listbox"
      [disabled]="disabled"
      [filter]="options?.length > 7"
      [options]="options"
      [optionLabel]="optionLabel"
      [placeholder]="placeholder || ''"
      [(ngModel)]="value"
      (ngModelChange)="onChange($event)"
      [showClear]="dropdownShowClear">
      <ng-template let-item pTemplate="item">
        <div class="flex-col gap-1">
          @if (item) {
            <div
              class="flex-row middle"
              style="min-height: 2rem">
              @if (item.icon) {
                <div class="dropdown-icon" [ngClass]="item.icon"></div>
              }
              <div [class.ellipsis]="item.title || item.description">
                {{ item[optionLabel || 'label'] }}
              </div>
            </div>
          }
          @if (item) {
            <div
              class="description"
              [innerHTML]="item.title || item.description || ''">
            </div>
          }
        </div>
      </ng-template>
    </p-listbox>
  }

  @if (editActive && type === 'multi-select') {
    <p-multiSelect
      styleClass="multiselect"
      [appendTo]="appendTo"
      [disabled]="disabled"
      [filter]="options?.length > 7"
      [maxSelectedLabels]="3"
      [(ngModel)]="value"
      (ngModelChange)="onChange(value)"
      [options]="options"
      [optionLabel]="optionLabel"
      [overlayOptions]="{ baseZIndex: 2000 }"
      [panelStyleClass]="!multiSelectShowHeader ? 'p-multiselect-no-header' : options?.length <= 7 ? 'multiselect-toggle-all-but-no-filter' : ''"
      [placeholder]="placeholder || '&nbsp;'"
      [showToggleAll]="true">
      <ng-template let-values pTemplate="selectedItems">
        <div class="flex-row">
          @for (value of values; track value; let i = $index) {
            <div>
              <div class="flex-row gap-1 middle"
                style="min-height: 2rem; margin-right: .5rem;">
                @if (findOptionIconByValue(value)) {
                  <div class="dropdown-icon" [ngClass]="findOptionIconByValue(value)"></div>
                }
                <div class="title">{{ findOptionLabelByValue(value) }}</div>
                @if (i < values.length - 1) {
                  <div>,</div>
                }
              </div>
            </div>
          }
        </div>
      </ng-template>
      <ng-template let-item pTemplate="item">
        <div class="flex-col gap-1">
          @if (item) {
            <div
              class="flex-row gap-1 middle"
              style="min-height: 2rem">
              @if (item.icon) {
                <div class="dropdown-icon" [ngClass]="item.icon"></div>
              }
              <div [class.ellipsis]="item.title || item.description">
                {{ item[optionLabel || 'label'] }}
              </div>
            </div>
          }
          @if (item.title || item.description) {
            <div
              class="description"
              [innerHTML]="item.title || item.description || ''">
            </div>
          }
        </div>
      </ng-template>
    </p-multiSelect>
  }

  @if (editActive && type === 'richText') {
    <miradi-rtf-editor
      class="rtf-editor"
      [alwaysShowToolbar]="richTextAlwaysShowToolbar"
      [autoFocus]="autoFocus"
      [disabled]="disabled"
      [(value)]="value"
      (valueChange)="onChange($event)"
      [placeholder]="placeholder || ''">
    </miradi-rtf-editor>
  }

  @if (editActive && type === 'textarea') {
    <textarea
      #inputElement
      pTextarea
      name="textarea"
      [autocomplete]="autocomplete"
      [autofocus]="autoFocus"
      class="input"
      [disabled]="disabled"
      [minlength]="validationObject?.minLength"
      [maxlength]="validationObject?.maxLength"
      [(ngModel)]="value"
      (ngModelChange)="onChange($event)"
      [placeholder]="placeholder || ''"
      [rows]="rows || 4">
    </textarea>
  }

  @if (editActive && (!type || type === 'text')) {
    <input
      #inputElement
      pInputText
      name="text"
      [autocomplete]="autocomplete"
      [autofocus]="autoFocus"
      (blur)="['int32', 'int64'].indexOf(validationObject?.type) >= 0 ? roundToInt() : null;"
      class="input"
      [disabled]="disabled"
      [minlength]="validationObject?.minLength"
      [maxlength]="!validationObject?.maxLengthWarningOnly ? validationObject?.maxLength : undefined"
      [(ngModel)]="value"
      (ngModelChange)="onChange($event)"
      [placeholder]="placeholder || ''"
      [required]="validationObject?.minLength > 0"
      [step]="validationObject?.type === 'float' ? 'any' : ['int32', 'int64'].indexOf(validationObject?.type) >= 0 ? '1' : ''"
      [type]="['int32', 'int64', 'float'].indexOf(validationObject?.type) >= 0 ? 'number' : validationObject?.type || 'text'" />
  }

  @if (editActive && validationObject?.maxLength) {
    <div
      class="char-count"
      [class.error]="!validationObject?.maxLengthWarningOnly && (value?.length || 0) > validationObject?.maxLength"
      [class.warn]="validationObject?.maxLengthWarningOnly && (value?.length || 0) > validationObject?.maxLength">
      {{ value?.length || 0 }} / {{ validationObject?.maxLength }}
    </div>
  }

  @if (editActive && type === 'tags') {
    <p-autoComplete
      styleClass="tags"
      [appendTo]="appendTo"
      [addOnTab]="true"
      [allowDuplicate]="false"
      [disabled]="disabled"
      [multiple]="true"
      [(ngModel)]="value"
      (ngModelChange)="onChange($event)"
      [typeahead]="false">
    </p-autoComplete>
  }

</div>
